// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"a3cf53136a84eb7d","626":"b1a51af3534bd60f"}[chunkId] + ".css";
};